export default {
  clean: () => import("/tmp/build_5e3ab85d/layouts/clean.vue").then(m => m.default || m),
  default: () => import("/tmp/build_5e3ab85d/layouts/default.vue").then(m => m.default || m)
}